import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useCallback, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { createAhamoveOrder } from "../../../api/apiDeliveryPartner";
import { MessageResponse } from "../../../model/MessageResponse";
import { getProvinceSelectNew } from "../../../service/getSelectApi";

interface SelectModel {
  label: string;
  value: string;
}

interface CustomerDataModel {
  name: string;
  tel: string;
  address: string;
  province: string;
  ward: string;
  amountRemaining: number;
  deposit: number;
  amountTotal: number;
  typeShip: string;
  attribute24: string;
}

interface BranchDeliveryModel {
  orgId: number;
  mobile: string;
  province: string;
  commune: string;
  addressDetail: string;
  address: string;
}

const ConfirmInfoAhamove = ({
  orderNumber,
  onSuccess,
}: {
  orderNumber: string;
  onSuccess: any;
}) => {
  const [isSuccess, setIsSuccess] = useState<boolean>(true);

  const [orderHeader, setOrderHeader] = useState<any>({});
  const [customerData, setCustomerData] = useState<CustomerDataModel>({
    name: "",
    tel: "",
    address: "",
    province: "",
    ward: "",
    amountRemaining: 0,
    deposit: 0,
    amountTotal: 0,
    typeShip: "",
    attribute24: "",
  });

  const [branchDeliveryData, setBranchDeliveryData] =
    useState<BranchDeliveryModel>({
      orgId: 0,
      mobile: "",
      province: "",
      commune: "",
      addressDetail: "",
      address: "",
    });

  const [products, setProducts] = useState<any[]>([]);

  const [dataProvinceNew, setDataProvinceNew] = useState<SelectModel[]>([]);
  const [dataCommuneNewKH, setDataCommuneNewKH] = useState<SelectModel[]>([]);
  const [dataCommuneNewCN, setDataCommuneNewCN] = useState<SelectModel[]>([]);
  const [loadingCommuneCN, setLoadingCommuneCN] = useState<boolean>(true);
  const [dataBranch, setDataBranch] = useState<any[]>([]);

  const validateSpecificFields = (
    data: any,
    fieldsToCheck?: string[],
  ): boolean => {
    const key = !fieldsToCheck ? Object.keys(data) : fieldsToCheck;

    for (const field of key) {
      const value = data[field];
      if (!(field in data)) {
        return false;
      }
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      if (typeof value === "number" && value === 0) {
        return false;
      }
    }

    return true;
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceNew(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const fetchDataCommuneNew = async (idProvince: string, type: string) => {
    const dataSearch =
      idProvince && idProvince.length > 0 ? `&ProvinceIds=${idProvince}` : "";

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?Active=true${dataSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const dataSet = result
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        }));
      if (type === "KH") {
        setDataCommuneNewKH(dataSet);
      } else if (type === "CN") {
        setDataCommuneNewCN(dataSet);
      }
    }
  };

  const fetchDataBranch = async (idOrg: number, custData?: any) => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const data = res.data;
      setDataBranch(data);
      const activeHeader = custData || orderHeader;
      if (activeHeader?.isOffice124) {
        setBranchDeliveryData({
          orgId: 124,
          mobile: activeHeader?.senderPhone || activeHeader?.pick_tel || "",
          province: "Hà Nội",
          commune: "Minh Khai",
          addressDetail: "124 Minh Khai",
          address: "124 Minh Khai, Hai Bà Trưng, Hà Nội",
        });
      } else if (idOrg) {
        setBranchDeliveryData({
          orgId: idOrg,
          mobile:
            data.find((i: any) => String(i.id) === String(idOrg))
              ?.attribute11 ?? "",
          province:
            data.find((i: any) => String(i.id) === String(idOrg))?.attribute8 ??
            "",
          commune:
            data.find((i: any) => String(i.id) === String(idOrg))?.attribute9 ??
            "",
          addressDetail:
            data.find((i: any) => String(i.id) === String(idOrg))
              ?.attribute10 ?? "",
          address:
            data.find((i: any) => String(i.id) === String(idOrg))?.address ??
            "",
        });
      }
    }
  };

  const getDataOrder = async () => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response?.success) {
      const products = response.data?.orderDetail.map((item: any) => ({
        _id: item.itemId, // hoặc chuyển thành chuỗi: String(item.itemId)
        num: item.quality, // số lượng
        name: item.itemName, // tên sản phẩm
        price: item.priceFinal || 0, // giá (nếu không có thì để 0)
      }));
      const customerData = JSON.parse(response.data?.orderHeader?.attribute1);

      setProducts(products);
      setCustomerData({
        name: customerData.customerName ?? "",
        tel: customerData.telephoneNumber ?? "",
        address: customerData.customerAddress,
        province: String(customerData.customerProvinceId) ?? "",
        ward: String(customerData.customerCommuneId) ?? "",
        amountRemaining: response.data?.orderHeader.amountRemaining ?? 0,
        deposit: response.data?.orderHeader.deposit ?? 0,
        amountTotal: response.data?.orderHeader.amountTotal ?? 0,
        attribute24: response.data?.orderHeader?.attribute24 ?? "",
        typeShip: customerData?.typeShip ?? "",
      });
      setOrderHeader(customerData);
      fetchDataBranch(response.data?.orderHeader?.orgId ?? 0, customerData);

      if (response.data?.orderHeader?.shipingVendor !== "Ahamove") {
        setIsSuccess(false);
      }
    }
  };

  const handleOrderAhamove = useCallback(async () => {
    const normalizedTypeShip = (customerData.typeShip || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

    const serviceId =
      normalizedTypeShip === "sieu toc"
        ? String(branchDeliveryData.address)
            .toLowerCase()
            .includes("hồ chí minh")
          ? "SGN-BIKE"
          : "HAN-BIKE"
        : normalizedTypeShip === "sieu toc tiet kiem"
          ? String(branchDeliveryData.address)
              .toLowerCase()
              .includes("hồ chí minh")
            ? "SGN-ECO"
            : "HAN-ECO"
          : String(branchDeliveryData.address)
                .toLowerCase()
                .includes("hồ chí minh")
            ? "SGN-BIKE"
            : "HAN-BIKE";

    const dataAhamove = {
      order_time: 0,
      path: [
        {
          address: branchDeliveryData.address
            .split("-")
            .map((i) => i.trim())
            .join(", "),
          short_address: String(branchDeliveryData.address || "")
            .toLowerCase()
            .includes("hồ chí minh")
            ? "Hồ Chí Minh"
            : String(branchDeliveryData.address || "")
                  .toLowerCase()
                  .includes("hà nội")
              ? "Hà Nội"
              : null,
          name: "Giao vận Hacom",
          mobile: branchDeliveryData.mobile,
          remarks: "Đến nơi lấy hàng đọc mã đơn để nhận hàng",
        },
        {
          address: [
            customerData.address,
            getValueById(String(customerData.ward), dataCommuneNewKH, "label"),
            getValueById(
              String(customerData.province),
              dataProvinceNew,
              "label",
            ),
          ]
            .filter((i) => i && String(i).length > 0)
            .map((i) => i.trim())
            .join(", "),
          short_address: String(branchDeliveryData.address || "")
            .toLowerCase()
            .includes("hồ chí minh")
            ? "Hồ Chí Minh"
            : String(branchDeliveryData.address || "")
                  .toLowerCase()
                  .includes("hà nội")
              ? "Hà Nội"
              : null,
          name: customerData.name,
          mobile: customerData.tel,
          cod:
            customerData.attribute24 === "Giao Hàng Thu Tiền(COD)"
              ? (customerData.amountRemaining || 0) -
                (customerData.deposit || 0)
              : 0,
          item_value: customerData.amountTotal,
          tracking_number: orderNumber,
          remarks: "Gọi điện trước khi giao. Giao hàng cẩn thận",
        },
      ],
      service_id: serviceId, // HAN-BIKE: Siêu tốc, HAN-ECO: Siêu tốc tiết kiệm
      // requests: [
      //   {
      //     _id:
      //       customerData.typeShip === "Siêu tốc"
      //         ? "HAN-BIKE-TRANSFER-COD"
      //         : customerData.typeShip === "Siêu tốc tiết kiệm"
      //         ? "HAN-ECO-TRANSFER-COD"
      //         : "HAN-SAMEPRICE-TRANSFER-COD", // Đồng giá 25k
      //   },
      // ],
      payment_method: "BALANCE",
      remarks:
        "Tài xê không cần gọi shop , vào trực tiếp của hàng , đọc mã đơn cho bộ phận kho để lấy hàng",
      items: products,
    };

    const responseAhamove = await createAhamoveOrder(dataAhamove);
    if (responseAhamove?.data?.order_id) {
      // Parse attribute1 từ JSON sang object
      const currentAttribute1 = orderHeader;

      // Thêm sharedLink vào object
      const updatedAttribute1 = {
        ...currentAttribute1,
        sharedLink: responseAhamove?.data?.shared_link,
      };

      // Chuyển lại thành JSON và lưu vào database
      await repositoryPos.post("/api/v1/CreateSellItem/update-attribute1", {
        orderNumber: orderNumber,
        attribute1: JSON.stringify(updatedAttribute1),
      });

      setTimeout(() => {
        NotificationExtension.Success("Tạo đơn Ahamove thành công");
      }, 1000); // Delay 200ms
    } else {
      setTimeout(() => {
        NotificationExtension.Fails(
          `Tạo đơn Ahamove thất bại: ${responseAhamove?.description}`,
        );
      }, 1000); // Delay 200ms

      // Ghi log lỗi vào hệ thống
      await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
        orderNumber: orderNumber,
        attribute42:
          responseAhamove?.description ||
          "Lỗi không xác định khi tạo đơn Ahamove",
      });
    }
  }, [branchDeliveryData, customerData]);

  useEffect(() => {
    if (orderNumber && String(orderNumber).length > 0) {
      getDataOrder();
      fetchDataProvinceNew();
    } else {
      setIsSuccess(false);
    }
  }, [orderNumber]);

  useEffect(() => {
    if (customerData.province && customerData.province.length > 0) {
      fetchDataCommuneNew(customerData.province, "KH");
    }
  }, [customerData.province]);

  useEffect(() => {
    if (branchDeliveryData.province && branchDeliveryData.province.length > 0) {
      setLoadingCommuneCN(true);
      fetchDataCommuneNew(branchDeliveryData.province, "CN").finally(() =>
        setLoadingCommuneCN(false),
      );
    }
  }, [branchDeliveryData.province]);

  return (
    <Box maw={650} w={"50vw"}>
      <Grid mt={5}>
        <Grid.Col span={12}>
          <Divider
            mt={10}
            label="Thông tin khách hàng"
            labelPosition="center"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            label={"Tên khách hàng"}
            placeholder="Nhập tên khách hàng"
            disabled={!isSuccess}
            value={customerData.name}
            onChange={(e) =>
              setCustomerData((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            withAsterisk
            error={
              !customerData.name || customerData.name.length === 0
                ? "Tên khách hàng không được bỏ trống !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            label={"Số điện thoại"}
            placeholder="Nhập số điện thoại"
            type="number"
            disabled={!isSuccess}
            value={customerData.tel}
            onChange={(e) => {
              setCustomerData((prev) => ({
                ...prev,
                tel: e.target.value,
              }));
            }}
            withAsterisk
            error={
              !customerData.tel || customerData.tel.length === 0
                ? "SĐT khách hàng không được bỏ trống !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Tỉnh/TP (Khách hàng)"
            placeholder="Nhập Tỉnh/TP"
            data={dataProvinceNew}
            value={
              customerData.province && String(customerData.province).length > 0
                ? customerData.province
                : null
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            disabled={!isSuccess}
            onChange={(e) =>
              setCustomerData((prev) => ({
                ...prev,
                province: e ? e : "",
                ward: "",
              }))
            }
            withAsterisk
            error={
              !customerData.province || customerData.province.length === 0
                ? "Tỉnh/TP không được bỏ trống !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Phường/xã (Khách hàng)"
            placeholder="Nhập Phường/xã"
            data={dataCommuneNewKH}
            value={
              customerData.ward && String(customerData.ward).length > 0
                ? customerData.ward
                : null
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            disabled={
              !isSuccess ||
              !customerData.province ||
              String(customerData.province).length === 0
            }
            onChange={(e) =>
              setCustomerData((prev) => ({
                ...prev,
                ward: e ? e : "",
              }))
            }
            withAsterisk
            error={
              !customerData.ward || customerData.ward.length === 0
                ? "Phường/xã không được bỏ trống !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Địa chỉ cụ thể ( Không bao gồm Tỉnh/TP, Phường/Xã )"
            placeholder="Nhập địa chỉ cụ thể"
            value={customerData.address}
            disabled={!isSuccess}
            onChange={(e) => {
              setCustomerData((prev) => ({
                ...prev,
                address: e.target.value,
              }));
            }}
            withAsterisk
            error={
              !customerData.address || customerData.address.length === 0
                ? "Địa chỉ khách hàng không được bỏ trống !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Địa chỉ đầy đủ"
            placeholder="Địa chỉ đầy đủ"
            value={[
              customerData.address,
              getValueById(
                String(customerData.ward),
                dataCommuneNewKH,
                "label",
              ),
              getValueById(
                String(customerData.province),
                dataProvinceNew,
                "label",
              ),
            ]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
            variant="filled"
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Divider mt={10} label="Điểm lấy hàng" labelPosition="center" />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Chi nhánh"
            placeholder="Nhập chi nhánh"
            data={dataBranch
              .filter((i) => i.id && i.code && i.name)
              .map((i) => ({
                label: `${i.code} - ${i.name}`,
                value: String(i.id),
              }))}
            value={
              branchDeliveryData.orgId ||
              String(branchDeliveryData.orgId).length === 0
                ? String(branchDeliveryData.orgId)
                : ""
            }
            variant="filled"
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            label="SĐT liên hệ lấy hàng của chi nhánh"
            placeholder="Nhập SĐT"
            type="number"
            value={branchDeliveryData.mobile}
            withAsterisk
            error={
              !branchDeliveryData.mobile ||
              branchDeliveryData.mobile.length === 0
                ? "Không tìm thấy SĐT liên hệ !"
                : false
            }
            variant="filled"
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Tỉnh/TP (Chi nhánh)"
            placeholder="Nhập Tỉnh/TP"
            data={dataProvinceNew}
            value={
              branchDeliveryData.province &&
              String(branchDeliveryData.province).length > 0
                ? branchDeliveryData.province
                : null
            }
            withAsterisk
            error={
              !branchDeliveryData.province ||
              branchDeliveryData.province.length === 0
                ? "Không tìm thấy Tỉnh/TP !"
                : null
            }
            variant="filled"
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Phường/xã (Chi nhánh)"
            placeholder="Nhập Phường/xã"
            data={dataCommuneNewCN}
            value={
              branchDeliveryData.commune &&
              String(branchDeliveryData.commune).length > 0
                ? branchDeliveryData.commune
                : null
            }
            withAsterisk
            error={
              !branchDeliveryData.commune ||
              branchDeliveryData.commune.length === 0
                ? "Không tìm thấy phường/xã !"
                : false
            }
            variant="filled"
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Địa chỉ cụ thể"
            placeholder="Địa chỉ cụ thể"
            value={branchDeliveryData.addressDetail}
            error={
              !branchDeliveryData.addressDetail ||
              branchDeliveryData.addressDetail.length === 0
                ? "Không tìm thấy địa chỉ cụ thể !"
                : false
            }
            variant="filled"
            readOnly
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Địa chỉ chi nhánh"
            placeholder="Nhập địa chỉ chi nhánh"
            value={branchDeliveryData.address}
            withAsterisk
            error={
              !branchDeliveryData.address ||
              branchDeliveryData.address.length === 0
                ? "Không tìm thấy địa chỉ cụ thể !"
                : null
            }
            variant="filled"
            readOnly
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} align={"center"} mt={5}>
        <Button
          leftSection={<IconCheck size={16} />}
          disabled={
            !isSuccess ||
            loadingCommuneCN ||
            !validateSpecificFields(customerData, [
              "name",
              "tel",
              "address",
              "province",
              "ward",
              "typeShip",
            ]) ||
            !validateSpecificFields(branchDeliveryData)
          }
          onClick={() => {
            handleOrderAhamove();
          }}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default ConfirmInfoAhamove;
